import { render, staticRenderFns } from "./ticket-details.vue?vue&type=template&id=6476b8ee&scoped=true&"
import script from "./ticket-details.vue?vue&type=script&lang=js&"
export * from "./ticket-details.vue?vue&type=script&lang=js&"
import style0 from "./ticket-details.vue?vue&type=style&index=0&id=6476b8ee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6476b8ee",
  null
  
)

export default component.exports